import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserBanksService } from 'src/app/api/user-banks.service';
import type { BankDetails } from 'src/app/models/bank-details';

@Component({
  selector: 'bank-details-ticket',
  templateUrl: './bank-details-ticket.component.html',
  styleUrls: ['./bank-details-ticket.component.scss']
})
export class BankDetailsTicketComponent implements OnInit {
  @Input() form: FormGroup;
  @Output() fileSelected = new EventEmitter<any>();

  bankDetails: BankDetails;

  constructor(private userBanksService: UserBanksService) { }

  ngOnInit() {
    this.userBanksService.getDefaultBank().subscribe(response => {
      this.form.get('bankDetailsChange.oldIban').setValue(response.iban ? response.iban : ' ');
      this.form.get('bankDetailsChange.oldBankName').setValue(response.bankName ? response.bankName : ' ');
      // tslint:disable-next-line: max-line-length
      this.form.get('bankDetailsChange.oldBankAccountHolderName').setValue(response.accountHolderLegalName ? response.accountHolderLegalName : ' ');
    });
  }

  onFileSelect(file) {
    this.form.get('bankDetailsChange.passport').setValue({
      name: file.file.name,
      content: file.base64
    });
  }

  onFileRemove() {
    this.form.get('bankDetailsChange.passport').reset();
  }

}
